<script setup>

import { computed } from 'vue';
import OfferCompareSection from './OfferCompareSection.vue';

const props = defineProps({

    modelValue: {
        type: Boolean,
        default: false
    },

    changes: {
        type: Array,
        default: () => []
    }

});

const emit = defineEmits([
    "update:modelValue"
]);

const groups = computed(() => {

    const result = {};

    props.changes.forEach(change => {

        if (!result[change.group]) {

            result[change.group] = [];

        }

        result[change.group].push(change);

    });

    return result;

});

const totalChanges = computed(() => props.changes.length);

function close() {

    emit(
        "update:modelValue",
        false
    );

}

</script>

<template>

<div
    v-if="modelValue"
    class="modal fade show"
    style="display:block;background:rgba(0,0,0,.5);z-index:1055"
>

    <div class="modal-dialog modal-xl modal-dialog-scrollable">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title">

                    <i class="fas fa-code-compare me-2"></i>

                    Porównanie zmian

                    <span class="badge bg-warning text-dark ms-2">

                        {{ totalChanges }}

                    </span>

                </h5>

                <button
                    class="btn-close"
                    @click="close"
                />

            </div>

            <div class="modal-body">

                <div
                    v-if="totalChanges === 0"
                    class="alert alert-success"
                >

                    <i class="fas fa-check-circle me-2"></i>

                    Nie wykryto żadnych zmian.

                </div>

                <template v-else>

                    <OfferCompareSection

                        v-for="(items, groupName) in groups"

                        :key="groupName"

                        :title="groupName"

                        :icon="items[0].icon"

                        :changes="items"

                    />

                </template>

            </div>

            <div class="modal-footer">

                <button
                    class="btn btn-secondary"
                    @click="close"
                >

                    Zamknij

                </button>

            </div>

        </div>

    </div>

</div>

</template>

<style scoped>

.modal-content{

    border-radius:12px;

}

.modal-header{

    background:#f8f9fa;

}

.modal-title{

    display:flex;

    align-items:center;

}

</style>